import Vue from "vue";
import MasterService from "@/services/MasterService";
import store from "@/store";

function initialState() {
  return {
    addOnsList: [],
    selectedAddons: [],
    selectedAddonsTotalPrice: 0,
    totalAddonsAdditionalTaxes: 0,
    addonsAdditionalCharges: []
  };
}
const state = initialState();
const mutations = {
  SET_ADD_ONS_LIST: (state, payload) => {
    if (payload && payload.length > 0) {
      state.addOnsList = payload.map(x => {
        x["quantity"] = 0;
        return x;
      });
    }
  },
  SELECT_ADD_ON: (state, payload) => {
    let obj = {
      ...payload,
      quantity: 1,
      additionalCharges: []
    };
    state.selectedAddons.push(obj);
  },
  SET_ADDITIONAL_CHARGES: (state, { listIndex, data }) => {
    if (data.Records.length > 0) {
      state.selectedAddons[listIndex]["additionalCharges"] = data.Records;
    }
  },
  CALCULATE_ADD_ONS_PRICE: (state, payload) => {
    state.selectedAddonsTotalPrice = 0;
    state.totalAddonsAdditionalTaxes = 0;
    if (state.selectedAddons && state.selectedAddons.length > 0) {
      state.selectedAddons.map(x => {
        state.selectedAddonsTotalPrice += x.add_on_item_price * x.quantity;
        if (
          x.hasOwnProperty("additionalCharges") &&
          x.additionalCharges.length > 0
        ) {
          x.additionalCharges.map(tax => {
            let listIndex = state.addonsAdditionalCharges.findIndex(
              z => z.ct_id == tax.ct_id
            );
            if (listIndex > -1) {
              x.ct_id === state.addonsAdditionalCharges[listIndex].ct_id
                ? (state.addonsAdditionalCharges[listIndex].totalTax =
                    tax.charge_value * x.quantity)
                : (state.addonsAdditionalCharges[listIndex].totalTax +=
                    tax.charge_value * x.quantity);
            } else if (listIndex < 0) {
              tax["totalTax"] = tax.charge_value * x.quantity;
              state.addonsAdditionalCharges.push(tax);
            }
            state.totalAddonsAdditionalTaxes += tax.charge_value * x.quantity;
          });
        }
      });
    }
  },
  REMOVE_ON_ADD_ONS_ITEMS: (state, payload) => {
    console.log("payload :>> ", payload);
    if (payload.hasOwnProperty("index") && String(payload.index).length > 0)
      state.selectedAddons.splice(payload.index, 1);
  },
  INCREASE_ADD_ONS_ITEM: (state, payload) => {
    if (payload.hasOwnProperty("index") && String(payload.index).length > 0)
      state.selectedAddons[payload.index].quantity++;
  },
  DECREASE_ADD_ONS_ITEM: (state, payload) => {
    if (
      payload.hasOwnProperty("index") &&
      String(payload.index).length > 0 &&
      state.selectedAddons[payload.index].quantity > 0
    )
      state.selectedAddons[payload.index].quantity--;
    if (
      payload.hasOwnProperty("index") &&
      String(payload.index).length > 0 &&
      state.selectedAddons[payload.index].quantity === 0
    )
      state.selectedAddons.splice(payload.index, 1);
  },
  RESET_ADD_ON_STORE: (state, payload) => {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  }
};
const actions = {
  fetchAddonsList: ({ dispatch, commit, state }, payload) => {
    MasterService.GetAllAddonsList()
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          await commit("SET_ADD_ONS_LIST", data.Records);
          await vmVue.$root.$emit("bv::show::modal", "add-ons-modal");
        } else {
          data.message
            ? Vue.toasted.show(data.message || "Opps! Something went wrong")
            : "";
        }
      })
      .catch(error => {
        Vue.toasted.show(
          "Sorry! Something went wrong. kindly contact your administrator"
        );
      });
  },
  onSelectAddon: async ({ dispatch, commit, state }, payload) => {
    let AddOnIndex = state.selectedAddons.findIndex(
      x => x.add_on_id == payload.add_on_id
    );
    if (AddOnIndex != -1) {
      state.selectedAddons[AddOnIndex].quantity++;
    } else {
      await commit("SELECT_ADD_ON", payload);
    }
    await vmVue.$root.$emit("bv::hide::modal", "add-ons-modal");
    if (payload.is_tax_applicable && payload.is_tax_applicable == "Y") {
      let request_payload = {
        add_on_id: payload.add_on_id
      };
      let listIndex = state.selectedAddons.findIndex(
        x => x.add_on_id == payload.add_on_id
      );
      MasterService.GetSingleAddonCharges(request_payload)
        .then(async response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            await commit("SET_ADDITIONAL_CHARGES", { listIndex, data });
            await commit("CALCULATE_ADD_ONS_PRICE", payload);
            // if (store.getters.hasOwnProperty("customerID") && store.getters.customerID) {
            await store.dispatch("validateCustomerPoints");
            // }
          }
        })
        .catch(err => {
          Vue.toasted.show(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    } else {
      await commit("CALCULATE_ADD_ONS_PRICE", payload);
      await store.dispatch("validateCustomerPoints");
    }
  },
  onRemoveAddonList: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("REMOVE_ON_ADD_ONS_ITEMS", payload);
    await commit("CALCULATE_ADD_ONS_PRICE", payload);
    await store.dispatch("validateCustomerPoints");
  },
  onIncreaseAddonItem: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("INCREASE_ADD_ONS_ITEM", payload);
    await commit("CALCULATE_ADD_ONS_PRICE", payload);
    await store.dispatch("validateCustomerPoints");
  },
  onDecreaseAddonItem: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("DECREASE_ADD_ONS_ITEM", payload);
    await commit("CALCULATE_ADD_ONS_PRICE", payload);
    await store.dispatch("validateCustomerPoints");
  },
  ResetAddonData: async ({ dispatch, commit, state }, { ...payload }) => {
    await commit("RESET_ADD_ON_STORE");
  }
};
const getters = {
  addOns: state => state.addOnsList,
  selectedAddons: state => state.selectedAddons,
  selectedAddonsTotalPrice: state => state.selectedAddonsTotalPrice,
  totalAddonsAdditionalTaxes: state => state.totalAddonsAdditionalTaxes,
  addonsAdditionalCharges: state => state.addonsAdditionalCharges
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/AddOnsStore.js